module.exports = __webpack_public_path__ + "44f6d70c6c63bf83bf7fac3c594a359b.svg";